import React from 'react';
import { FiX, FiCheck, FiUser, FiStar, FiTruck, FiMapPin } from 'react-icons/fi';
import { motion, AnimatePresence } from 'framer-motion';
import { formatTND, formatMoverRating, formatDistanceKm } from './utils/helpers';

const ComparisonPanel = ({ selectedMovers, onRemove, onClear, onCompare }) => {
  if (selectedMovers.length === 0) return null;

  return (
    <motion.div
      initial={{ y: 100, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      exit={{ y: 100, opacity: 0 }}
      className="fixed bottom-0 left-0 right-0 bg-gradient-to-t from-gray-900 via-gray-800 to-gray-800 border-t border-gray-700 shadow-2xl z-[1100]"
    >
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 bg-amber-500 rounded-lg flex items-center justify-center">
              <FiCheck className="w-5 h-5 text-white" />
            </div>
            <div>
              <h3 className="font-bold text-white">
                {selectedMovers.length} déménageur{selectedMovers.length > 1 ? 's' : ''} sélectionné{selectedMovers.length > 1 ? 's' : ''}
              </h3>
              <p className="text-sm text-gray-400">Comparez les options</p>
            </div>
          </div>
          <div className="flex items-center gap-2">
            <button
              onClick={onCompare}
              className="px-4 py-2 bg-amber-500 hover:bg-amber-600 text-white rounded-lg font-semibold transition-colors flex items-center gap-2"
            >
              Comparer
            </button>
            <button
              onClick={onClear}
              className="px-4 py-2 bg-gray-700 hover:bg-gray-600 text-white rounded-lg transition-colors"
            >
              Tout effacer
            </button>
          </div>
        </div>

        <div className="flex gap-3 overflow-x-auto pb-2">
          <AnimatePresence>
            {selectedMovers.map((mover) => (
              <motion.div
                key={mover.id}
                initial={{ opacity: 0, scale: 0.8 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0, scale: 0.8 }}
                className="flex-shrink-0 bg-gray-800 rounded-lg p-3 border border-gray-700 min-w-[200px]"
              >
                <div className="flex items-start justify-between mb-2">
                  <div className="flex items-center gap-2">
                    <div className="w-8 h-8 bg-gray-700 rounded-full flex items-center justify-center">
                      <FiUser className="w-4 h-4 text-amber-400" />
                    </div>
                    <div>
                      <div className="font-semibold text-white text-sm">
                        {mover.firstName} {mover.lastName}
                      </div>
                    </div>
                  </div>
                  <button
                    onClick={() => onRemove(mover.id)}
                    className="text-gray-400 hover:text-white"
                  >
                    <FiX className="w-4 h-4" />
                  </button>
                </div>
                <div className="space-y-1 text-xs text-gray-400">
                  <div className="flex items-center gap-1">
                    <FiStar className="w-3 h-3 text-yellow-400" />
                    {formatMoverRating(mover.rating, mover.reviewCount ?? mover.reviews)}
                  </div>
                  <div className="flex items-center gap-1">
                    <FiMapPin className="w-3 h-3" />
                    {formatDistanceKm(mover.distance)} km
                  </div>
                  <div className="font-semibold text-amber-400 mt-1">
                    {formatTND(mover.price || 0)}
                  </div>
                </div>
              </motion.div>
            ))}
          </AnimatePresence>
        </div>
      </div>
    </motion.div>
  );
};

export default ComparisonPanel;





